import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { toastr } from 'react-redux-toastr';
import blacklistRepository from '../../repository/blacklist/BlacklistRepository';
import HorizontalSpacer from '../../shared/components/HorizontalSpacer/HorizontalSpacer';
import NoDataFound from '../../shared/components/NoDataFound/NoDataFound';
import BlacklistSearch from './components/BlacklistSearch';
import BlacklistTable from './components/BlacklistTable';
import RemoveFromBlacklistDialog from './components/RemoveFromBlacklistDialog';
import styles from './BlacklistOverview.module.css';

export default class BlacklistOverview extends React.Component {
  state = {
    entries: [],
    isBusy: false,
    searchEmail: '',
    removeDialogOpen: false,
    selectedEmail: null,
  };

  handleSearch = (email) => {
    const trimmed = (email || '').trim();
    this.setState({ isBusy: true, searchEmail: trimmed });
    const seq = (this._blacklistSearchSeq =
      (this._blacklistSearchSeq || 0) + 1);
    blacklistRepository
      .getBlacklistEntries(trimmed)
      .then((list) => {
        if (seq !== this._blacklistSearchSeq) {
          return;
        }
        this.setState({ entries: list, isBusy: false });
      })
      .catch(() => {
        if (seq !== this._blacklistSearchSeq) {
          return;
        }
        toastr.error('Error', 'Failed to load blacklist');
        this.setState({ isBusy: false });
      });
  };

  handleOpenRemoveDialog = (email) => {
    this.setState({ removeDialogOpen: true, selectedEmail: email });
  };

  handleCloseRemoveDialog = () => {
    this.setState({ removeDialogOpen: false, selectedEmail: null });
  };

  handleRemoveFromBlacklist = () => {
    const { selectedEmail } = this.state;
    return blacklistRepository
      .removeFromBlacklist(selectedEmail)
      .then(() => {
        toastr.success('Success', 'Removed from blacklist');
        this.handleCloseRemoveDialog();
        this.reloadEntries();
      })
      .catch(() => {
        toastr.error('Error', 'Failed to remove from blacklist');
      });
  };

  reloadEntries = () => {
    const { searchEmail } = this.state;
    if (searchEmail) {
      this.handleSearch(searchEmail);
    }
  };

  render() {
    const { entries, isBusy, removeDialogOpen, selectedEmail } = this.state;

    return (
      <div className={styles.blacklistOverview}>
        <h1>Blacklist</h1>
        <p className={styles.subtitle}>
          Keycloak brute-force and disabled accounts (end-user and merchant
          realms). Search by email.
        </p>
        <BlacklistSearch onSearch={this.handleSearch} />
        <HorizontalSpacer />
        {isBusy ? (
          <CircularProgress />
        ) : (
          <div>
            {entries.length ? (
              <BlacklistTable
                entries={entries}
                onRemove={this.handleOpenRemoveDialog}
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        )}
        <RemoveFromBlacklistDialog
          open={removeDialogOpen}
          email={selectedEmail}
          onClose={this.handleCloseRemoveDialog}
          onConfirm={this.handleRemoveFromBlacklist}
        />
      </div>
    );
  }
}
